// extracted by mini-css-extract-plugin
export default {"label":"Nebenkosten_label__i5bK2","input":"Nebenkosten_input__+qYzf","rowElement":"Nebenkosten_rowElement__NSm-n","button":"Nebenkosten_button__4yWpX"};